import React from 'react';
import { FormRow } from '../Form/FormRow';
import { FormColumnContent } from '../Form/FormColumnContent';
import { FormColumn } from '../Form/FormColumn';
import { BestellungDetails } from '../../types';
import { getWunschterminDatumText, getWunschterminZeitraumDisplayText } from '../../helper/date-helper';
import { useSelector } from 'react-redux';
import { selectIsDebitor, selectIsFarmleiter } from '../../../store/Navigation.store';

export const WunschterminFormRow: React.FC<{ bestellung: BestellungDetails }> = ({ bestellung }) => {
    const isDebitor = useSelector(selectIsDebitor);
    const isFarmleiter = useSelector(selectIsFarmleiter);
    const wunschterminText = getWunschterminDatumText(bestellung.wunschtermin);
    const wunschterminISOWEVon = bestellung.wunschterminWEVon;
    const wunschterminISOWEBis = bestellung.wunschterminWEBis;
    const wunschterminZeitraumDisplayText = getWunschterminZeitraumDisplayText(wunschterminISOWEVon, wunschterminISOWEBis);
    return (
        <FormRow>
            <FormColumnContent
                content={wunschterminZeitraumDisplayText}
                title={`Wunschtermin ${isDebitor || isFarmleiter ? 'Warenempfänger' : ''}`}
            />
            {isDebitor || isFarmleiter ? (
                <FormColumn />
            ) : (
                <FormColumnContent content={wunschterminText} title={'Wunschtermin Landwarenhandel'} />
            )}
        </FormRow>
    );
};
